
import React from 'react';
import axios from "axios";
import { URL, getAuthorizationHeader } from '../../constans/constants';
import { informacionTramite } from './TramitesService';
import safeRedirectManager from '../seguridad/SafeRedirectComponent';
import BreadCrumComponent from "../componentes/BreadCrumComponent";

class VistaTramitePDF extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      fechaCarga: "",
      empleado: "",
      estado: "",
      estadoMTESS: false,
      redirect: "",
      comentario: "",
      tieneComentario: false,
      tieneAdjunto: false,
      loading: true,
      error: null,
      pdfArrayBuffer: null,
      viewerReady: false,
    }
  }

  componentDidMount() {
    this.fetchPDF();
    informacionTramite(this.props.match.params.idTramite)
      .then((resp) => {
        if (!resp.error) {
          this.setState({
            tieneComentario: resp.datos.tieneComentario,
            comentario: resp.datos.detalle,
            tieneAdjunto: resp.datos.tieneAdjunto === true,
          });
        }
      })
      .catch((err) => {
        console.error('Error obteniendo datos del trámite:', err);
      });
  }

  componentWillUnmount() {
    const viewerFrame = document.getElementById('pdf-js-viewer');
    if (viewerFrame && viewerFrame.contentWindow) {
      viewerFrame.contentWindow.document.removeEventListener('click', this.handlePDFClick);
      viewerFrame.contentWindow.document.removeEventListener('contextmenu', this.handlePDFRightClick);
    }
  }

  fetchPDF = async () => {
    try {
      const requestUrl = `${URL}tramite/pdf/${this.props.match.params.idTramite}`;
      const response = await axios.get(requestUrl, {
        ...getAuthorizationHeader(),
        responseType: 'arraybuffer'
      });

      this.setState({ pdfArrayBuffer: response.data, loading: false }, () => {
        if (this.state.viewerReady) {
          this.loadPDFIntoViewer(this.state.pdfArrayBuffer);
        }
        // Si el viewer todavía no cargó, handleViewerLoad lo hará cuando esté listo
      });
    } catch (error) {
      console.error('Error fetching PDF:', error);
      this.setState({ error: 'Error al cargar el PDF', loading: false });
    }
  }

  handleViewerLoad = () => {
    this.setState({ viewerReady: true }, () => {
      if (this.state.pdfArrayBuffer) {
        this.loadPDFIntoViewer(this.state.pdfArrayBuffer);
      }
    });
  }

  loadPDFIntoViewer = async (arrayBuffer) => {
    const viewerFrame = document.getElementById('pdf-js-viewer');
    if (!viewerFrame) return;
    try {
      const viewerWindow = viewerFrame.contentWindow;
      if (!viewerWindow || !viewerWindow.PDFViewerApplication) return;
      await viewerWindow.PDFViewerApplication.initializedPromise;
      await viewerWindow.PDFViewerApplication.open({ data: new Uint8Array(arrayBuffer) });
      viewerWindow.document.addEventListener('click', this.handlePDFClick);
      viewerWindow.document.addEventListener('contextmenu', this.handlePDFRightClick);
    } catch (error) {
      console.error('Error loading PDF into viewer:', error);
    }
  }

  handlePDFClick = (event) => {
    const target = event.target;
    if (target.tagName === 'A' && target.href) {
      event.preventDefault();
      safeRedirectManager.safeRedirect(target.href);
    }
  }

  handlePDFRightClick = (event) => {
    const target = event.target;
    if (target.tagName === 'A' && target.href) {
      event.preventDefault();
    }
  }

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  setPantallaAnterior = () => {
    return (localStorage.getItem("urlAnterior")).substring(localStorage.getItem("urlAnterior").indexOf("#") + 1)
  }

  descargarTramite = () => {
    window.location.href = URL + 'tramite/pdf/' + this.props.match.params.idTramite + "/descargar";
  }

  descargarAdjunto = () => {
    window.location.href = URL + 'tramite/adjuntos/' + this.props.match.params.idTramite + '/descargar';
  }

  render() {
    return (
      <div className="template-base">
        <header className="component-header">
          <div className="page-container">
            <BreadCrumComponent
              backUrl={this.setPantallaAnterior()}
              breadcrumbs={[
                { label: 'Trámites', path: this.setPantallaAnterior() },
                { label: 'Visor de documento', path: '' }
              ]}
            />
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title">
                  {this.props.match?.params?.nombre
                    ? this.props.match.params.nombre
                    : 'Visor de Trámite'}
                </h1>
                <p className="page-description">
                  Detalle del documento del trámite
                </p>
              </div>
              <div className="head-actions">
                {this.state.tieneAdjunto && (
                  <button
                    className="btn-medium btn-base-outline"
                    onClick={this.descargarAdjunto}
                  >
                    <span className="material-symbols-outlined">attach_file</span>
                    Descargar adjunto
                  </button>
                )}
                <button
                  className="btn-medium btn-base-outline"
                  onClick={this.descargarTramite}
                >
                  <span className="material-symbols-outlined">download</span>
                  Descargar
                </button>
              </div>
            </div>
          </div>
        </header>

        <div className="wrapperContent">
          <div className="component-documento">
            <div className="page-container container-sm">
              {this.state.tieneComentario && (
                <div className="card" style={{ marginBottom: '20px' }}>
                  <div className="caption-area">
                    <h5>Comentario</h5>
                    <p className="page-description">{this.state.comentario}</p>
                  </div>
                </div>
              )}

              <div className="card">
                <div id="container-file">
                  {this.state.error ? (
                    <div>{this.state.error}</div>
                  ) : (
                    <iframe
                      id="pdf-js-viewer"
                      src="/mirecibo/visor/viewer.html?file="
                      title="webviewer"
                      frameBorder="0"
                      width="100%"
                      height="1000px"
                      onLoad={this.handleViewerLoad}
                    ></iframe>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default VistaTramitePDF;
